<template>
    <div>
        <p v-show="showSuccess" class="text-green-500 border p-2">{{success}}</p>
        <p v-show="showSuccess" class="text-red-500 border p-2">{{error}}</p>
        <div class="mt-5 border p-2">
            <form @submit.prevent="submitDetails" enctype="multipart/form-data">
                <div>
                    <div>
                        <div class="mt-4">
                            <label for="lasra" class="font-bold">Lasra</label>
                            <input style="display:none" type="file" name="lasra" id="lasra" @change="onLasra" ref="lasraUpload">
                            <p class=" text-sm bg-gray-100 p-2 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.lasraUpload.click()">--upload file-- {{this.lasraName}} </p>
                            <p v-if="lasraValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                        </div>
                        
                    </div>

                    <div class="mt-4">
                        <label for="vehicleType" class=" font-bold">Vehicle Type</label>
                        <select class="bg-gray-100 border w-full p-1 rounded-lg" name="vehicleType" id="vehicleType" v-model="vehicleType">
                            <option selected value="" disabled>Choose</option>
                            <option value="Bike">Bike</option>
                            <option value="Car">Car</option>
                            <option value="Truck">Truck</option>
                        </select>
                        <p v-if="vehicleTypeValidity === 'invalid'" class=" text-xs text-red-500">this field must not be empty</p>
                    </div>

                    <div class="mt-4">
                        <div>
                            <label class="font-bold" for="model">Vehicle Model</label>
                            <input class="border w-full text-sm rounded-lg bg-gray-100 p-2" type="text" name="model" id="model" placeholder="Enter Vehicle Model" v-model="model">
                            <p v-if="modelValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                        </div>

                    </div>

                    <div class="mt-4">
                        <div>
                            <label class="font-bold" for="prodYear">Vehicle Production Year</label><br>
                            <input class="border text-sm w-full rounded-lg bg-gray-100 p-2" type="text" name="ProdYear" id="ProdYear" placeholder="Enter Vehicle Prod Year" v-model="prodYear">
                            <p v-if="prodYearValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                        </div>
                    </div>

                    <div class="mt-4">
                        <div>
                            <label class="font-bold" for="plateNumber">License Plate No.</label><br>
                            <input class="border w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="plateNumber" id="plateNumber" placeholder="Enter Your Plate No." v-model="plateNumber">
                            <p v-if="plateNumberValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div>
                            <label class="font-bold" for="chassisNumber">Chassis Number</label><br>
                            <input class="border w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="chassisNumber" id="chassisNumber" placeholder="Type here" v-model="chasis">
                            <p v-if="chasisValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div>
                            <label class="font-bold" for="engineNumber">Engine Number</label><br>
                            <input class="border w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="engineNumber" id="engineNumber" placeholder="Type here" v-model="engine">
                            <p v-if="engineValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                        </div>
                    </div>

                    <div class="mt-4">
                        <label for="vehicleReceipt" class=" font-bold">Vehicle Receipt</label><br>
                        <input style="display:none" type="file" name="vehicleReceipt" id="vehicleReceipt" @change="onVehicleReceipt" ref="vehicleReceiptUpload">
                        <p class="w-full text-sm p-2 bg-gray-100 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.vehicleReceiptUpload.click()">--upload file--{{this.vehicleReceiptName}}</p>
                        <p v-if="vehicleReceiptValidity === 'invalid'" class=" text-xs text-red-500">please upload file</p>
                    </div>
                    <div class="mt-4">
                        <label class="font-bold" for="roadWorthiness">Road Worthiness</label>
                        <input style="display:none" type="file" name="roadWorthiness" id="roadWorthiness" @change="onRoadWorthiness" ref="roadWorthinessUpload">
                        <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.roadWorthinessUpload.click()">--upload file-- {{this.roadWorthinessName}} </p>
                        <p v-if="roadWorthinessValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                    </div>
                </div>

                
                

                <div class="mt-10 flex">
                    <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Submit</button>
                    <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                </div>
            </form>                              
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props:["id"],
    data() {
        return {
            rider: [],
            success: "",
            lasra: null,
            lasraName: null,
            vehicleType: '',
            model: '',
            prodYear: '',
            plateNumber: '',
            academicCertificate: null,
            academicCertificateName:null,
            others: null,
            othersName: null,
            isLoading: false,
            chasis: "",
            engine: "",
            roadWorthiness: null,
            roadWorthinessName: null,
            vehicleReceipt:null,
            vehicleReceiptName:null,

            lasraValidity: '',
            vehicleTypeValidity: '',
            modelValidity: '',
            prodYearValidity: '',
            plateNumberValidity: '',
            chasisValidity: '',
            engineValidity: '',
            roadWorthinessValidity: "",
            vehicleReceiptValidity:"",
            showSuccess: false,
            error: ""
        }
    },

    mounted() {
        this.networkError();
        this.getRider();
    },

    methods: {
        onLasra(event) {
            this.lasra = event.target.files[0]
            this.lasraName = event.target.files[0].name
        },
        onRoadWorthiness(event) {
            this.roadWorthiness = event.target.files[0]
            this.roadWorthinessName = event.target.files[0].name
        },
        onVehicleReceipt(event) {
            this.vehicleReceipt = event.target.files[0]
            this.vehicleReceiptName = event.target.files[0].name
        },

         getRider() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/check/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.rider = response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
        },


        submitDetails() {
            if (!this.lasra) {
                this.lasraValidity = 'invalid'
                setTimeout(() => {
                    this.lasraValidity = ''
                }, 3000);
            } else if (!this.vehicleType) {
                this.vehicleTypeValidity = 'invalid'
                setTimeout(() => {
                    this.vehicleTypeValidity = ''
                }, 3000);
            } else if (!this.model) {
                this.modelValidity = 'invalid'
                 setTimeout(() => {
                    this.modelValidity = ''
                }, 3000);
            } else if (!this.prodYear) {
                this.prodYearValidity = 'invalid'
                 setTimeout(() => {
                    this.prodYearValidity = ''
                }, 3000);
            } else if (!this.plateNumber) {
                this.plateNumberValidity = 'invalid'
                 setTimeout(() => {
                    this.plateNumberValidity = ''
                }, 3000);
            } else if(!this.chasis) {
                this.chasisValidity = 'invalid';
                 setTimeout(() => {
                    this.chasisValidity = ''
                }, 3000);
            } else if(!this.engine) {
                this.engineValidity = 'invalid';
                 setTimeout(() => {
                    this.engineValidity = ''
                }, 3000);
            }else if(!this.vehicleReceipt) {
                this.vehicleReceiptValidity = 'invalid';
                 setTimeout(() => {
                    this.vehicleReceiptValidity = ''
                }, 3000);
            } else if(!this.roadWorthiness) {
                this.roadWorthinessValidity = 'invalid';
                 setTimeout(() => {
                    this.roadWorthinessValidity = ''
                }, 3000);
            }
            else {
                this.isLoading = true
                let data = new FormData();

                data.append('email', this.id );
                data.append('lasra', this.lasra); 
                data.append('vehicleType', this.vehicleType); 
                data.append('vehicleYear', this.prodYear); 
                data.append('vehicleModel', this.model); 
                data.append('licenseNumber', this.plateNumber); 
                data.append('chasisNumber', this.chasis); 
                data.append('engineNumber', this.engine); 
                data.append('vehicleReceipt', this.vehicleReceipt); 
                data.append('roadWorthiness', this.roadWorthiness); 
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/riders/update`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: data
                })
                .then((response) => {
                    response;
                    this.isLoading = false
                    this.showSuccess = true
                    this.success = "Profile Updated Successfully"
                    this.lasraName= ""
                    this.vehicleType=""
                    this.prodYear= ""
                    this.plateNumber=""
                    this.model=""
                    this.chasis=""
                    this.engine=""
                    this.vehicleReceiptName=""
                    this.roadWorthinessName=""
                     setTimeout(() => {
                        this.success= ""
                        this.showSuccess = false;
                    }, 3000);
                    this.$emit("getRider");


                })

                .catch((error) => {
                    console.log(error)
                    this.error = error.response.data.message
                    setTimeout(() => {
                        this.error= ""
                    }, 3000);
                    this.isLoading = false;
                });
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>
